module.exports = __webpack_public_path__ + "img/Ktor_icon.5078f411.png";